import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-group',
	templateUrl: './icon-group.component.svg',
})
export class IconGroupComponent {}
